jQuery(document).ready(function($) {
  //added for increment and decrement
  if($('.input-number-increment').length > 0) {
    $('.input-number-increment').on('click', function () {
      if (!$(this).hasClass('disabledButton')) {
        var inputField = $(this).parent('div.col-sm-3').find('.input-number');
        $(inputField).val(parseInt(inputField.val()) + 1);
      }
    });
    
    $('.input-number-decrement').on('click', function () {
      if (!$(this).hasClass('disabledButton')) {
        var inputField = $(this).parent('div.col-sm-3').find('.input-number');
        if ($(inputField).val() <= 0) {
          $(inputField).val(0);
        } else {
          $(inputField).val(parseInt(inputField.val()) - 1);
        }
      }
    });
  }
  
  //for add to cart button
  if ($('.custom_add_to_cart').length > 0) {
    $('.custom_add_to_cart').on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.addClass('is-loading');
      
      var items = 0;
      var updates = '';
      var itemsArray = [];
      
      $('.input-number').each(function() {
        if ($(this).val() > 0) {
          if(items == 0) {
            updates = "updates[" + $(this).attr('vid') + "]=" + $(this).val();
          } else {
            updates = updates + "&" + "updates[" + $(this).attr('vid') + "]=" + $(this).val();
          }
          itemsArray.push({'id': $(this).attr('vid'), 'quantity': $(this).val()});
          items ++;
        }
      });
      
      if (items > 0) {
        let sections = 'cart-icon-bubble';
        if (document.querySelector('cart-drawer')) {
          sections += `,${document.querySelector('cart-drawer').closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',  
          dataType: 'json',
          data: {'items':itemsArray, 'sections_url': window.location.pathname, 'sections': sections},             
          success: function(data) {
            $this.removeClass('is-loading');

            console.log(data);

            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble) {
              cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
            }

            if (document.querySelector('cart-drawer')) {
              document.querySelector('cart-drawer').renderContents(
                data,
                theme.settings.afterAtc === 'drawer'
              );
            }
            else {
              window.location = '/cart';
            }
          },
          error: function(error) {
            var jsonobj = JSON.parse(error.responseText);
            alert(jsonobj.description);
            $this.removeClass('is-loading');
          }
        });
      }
      else {
        alert('Please select quantity for at least one variant');
      } 
    });
  }
    
  if ($('.checkout_login').length > 0) {
    $('.checkout_login').on('click', function () {
      var currentURL = location.href+'?cart=1';
      window.open('account/login?checkout_url=' + escape(currentURL), '_self', '');
    });
  }	
});